import axios from './axios';
import { MEDIA_API_URL } from './config';

// Validate bearer token by querying for list of media
export const validateBearerToken = async (bearerToken) => {
  try {
    return await axios({
      url: `${MEDIA_API_URL}/definition/media/search`,
      method: 'get',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${bearerToken}`,
      },
    });
  } catch (err) {
    throw (err);
    // TODO: handle errors
  }
};

export default {
  validateBearerToken,
};
